
import * as PGFuZHJvaWR4LmNvbXBvc2UucnVudGltZTpydW50aW1lLXNhdmVhYmxlPg from './androidx-compose-runtime-runtime-saveable.mjs';
import * as PGFuZHJvaWR4LmNvbXBvc2UucnVudGltZTpydW50aW1lPg from './androidx-compose-runtime-runtime.mjs';
import * as PG9yZy5qZXRicmFpbnMuY29tcG9zZS5tYXRlcmlhbDMuYWRhcHRpdmU6YWRhcHRpdmUtbGF5b3V0Pg from './compose-multiplatform-core-compose-material3-adaptive-adaptive-layout.mjs';
import * as PG9yZy5qZXRicmFpbnMuY29tcG9zZS5tYXRlcmlhbDMuYWRhcHRpdmU6YWRhcHRpdmU_ from './compose-multiplatform-core-compose-material3-adaptive-adaptive.mjs';
import * as PGtvdGxpbj4 from './kotlin-kotlin-stdlib.mjs';
import { __ALL_EXPORTS as PGFuZHJvaWR4LmNvbXBvc2UucnVudGltZTpydW50aW1lLXNhdmVhYmxlPg__ALL_EXPORTS } from './androidx-compose-runtime-runtime-saveable.mjs';
import { __ALL_EXPORTS as PGFuZHJvaWR4LmNvbXBvc2UucnVudGltZTpydW50aW1lPg__ALL_EXPORTS } from './androidx-compose-runtime-runtime.mjs';
import { __ALL_EXPORTS as PG9yZy5qZXRicmFpbnMuY29tcG9zZS5tYXRlcmlhbDMuYWRhcHRpdmU6YWRhcHRpdmUtbGF5b3V0Pg__ALL_EXPORTS } from './compose-multiplatform-core-compose-material3-adaptive-adaptive-layout.mjs';
import { __ALL_EXPORTS as PG9yZy5qZXRicmFpbnMuY29tcG9zZS5tYXRlcmlhbDMuYWRhcHRpdmU6YWRhcHRpdmU___ALL_EXPORTS } from './compose-multiplatform-core-compose-material3-adaptive-adaptive.mjs';
import { __ALL_EXPORTS as PGtvdGxpbj4__ALL_EXPORTS } from './kotlin-kotlin-stdlib.mjs';
import { __TAG as wasmTag, getCachedJsObject } from './kotlin-kotlin-stdlib.mjs'

// Placed here to give access to it from externals (js_code)
let wasmExports;

if (typeof process !== 'undefined' && process.release.name === 'node') {
    function doNotUseRequire() {
        throw new Error("Do not use top-level require. Prefer to use JS import or define your own require instead. Read more: https://kotl.in/r9txlt")
    }

    var require = new Proxy((function() {}), {
        apply(target, thisArg, argumentsList) {
            if (globalThis.require != null) {
                return globalThis.require.apply(thisArg, argumentsList);
            } else {
                doNotUseRequire();
            }
        },
        get(target, prop, receiver) {
            if (globalThis.require != null) {
                return Reflect.get(globalThis.require, prop);
            } else {
                doNotUseRequire();
            }
        },
    });
}

export function setWasmExports(exports) {
    wasmExports = exports;
}

const js_code = {

}

const StringConstantsProxy = new Proxy({}, {
  get(_, prop) { return prop; }
});

export const importObject = {
    js_code,
    intrinsics: {

        tag: wasmTag
    },
    "'": StringConstantsProxy,
    '<kotlin>': PGtvdGxpbj4__ALL_EXPORTS,
    '<org.jetbrains.compose.material3.adaptive:adaptive>': PG9yZy5qZXRicmFpbnMuY29tcG9zZS5tYXRlcmlhbDMuYWRhcHRpdmU6YWRhcHRpdmU___ALL_EXPORTS,
    '<androidx.compose.runtime:runtime>': PGFuZHJvaWR4LmNvbXBvc2UucnVudGltZTpydW50aW1lPg__ALL_EXPORTS,
    '<org.jetbrains.compose.material3.adaptive:adaptive-layout>': PG9yZy5qZXRicmFpbnMuY29tcG9zZS5tYXRlcmlhbDMuYWRhcHRpdmU6YWRhcHRpdmUtbGF5b3V0Pg__ALL_EXPORTS,
    '<androidx.compose.runtime:runtime-saveable>': PGFuZHJvaWR4LmNvbXBvc2UucnVudGltZTpydW50aW1lLXNhdmVhYmxlPg__ALL_EXPORTS,
};
    